module.exports = __webpack_public_path__ + "static/img/sin-imagen.3bd5943e.png";